import React from 'react';
import Backend from '../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import {
  Form,
  FormGroup,
  Label,
  CustomInput,
  FormFeedback,
  Row,
  Col,
  Button,
  Collapse,
} from 'reactstrap';
import Required from '../../UI/Required';
import zxcvbn from 'zxcvbn';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import { remove } from 'lodash';
import { Alert, Input, Button as CommonButton } from '../../UI/Common';
import helper from '../../../utils/helper';
import PasswordConfirmation from '../../UI/PasswordConfirmation';

//prettier-ignore
const workDays = [{value: '7', label: 'Su'}, {value: '1', label: 'Mo'}, {value: '2', label: 'Tu'}, {value: '3', label: 'We'}, {value: '4', label: 'Th'}, {value: '5', label: 'Fr'}, {value: '6', label: 'Sa'}];

const MyProfilePage = (props) => {
  //prettier-ignore
  const { t, isSubmitting, currentProfile = {} } = props;
  const [isChangePwd, setIsChangePwd] = React.useState(false);
  const form = {
    name: 'test',
    surname: 'this is',
    title: 'Mr',
    escalationLevel: undefined,
    escalationLevelName: '',
    email: 'test@test.com',
    password: 'P@ssword123',
    confirmPassword: 'P@ssword123',
    //prettier-ignore
    workDaysOfWeek: ['1', '2', '3', '4', '5', '6', '7'],
    startWork: new Date().setHours(8, 30),
    endWork: new Date().setHours(17, 0),
    workContact: 'work contact',
    nonWorkContact: 'non work contact',
    initials: 'TT',
    // departmentId: '',
    // departmentName: '',
    roleNames: '',
    roleNamesText: '',
    groupIdArray: [],
  };

  const passwordForm = {
    currentPassword: '',
    password: '',
    confirmPassword: '',
  };

  let timeFormat = 'HH:mm';
  if (props.i18n.language === 'en_US') {
    timeFormat = 'h:mm aa';
  }

  function getPasswordStrength(password) {
    if (password) {
      return zxcvbn(password).score;
    } else {
      return 0;
    }
  }

  const selectWorkDay = (e, day, workDays, setFieldValue) => {
    if (e.target.checked) {
      workDays.push(day);
    } else {
      remove(workDays, (workday) => workday === day);
    }
    setFieldValue(workDays);
  };
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values, isChangePwd) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onSubmit(values, isChangePwd);
    }
  }
  return (
    <Backend>
      <div className="content-inner">
        <Formik
          enableReinitialize
          initialValues={{ ...currentProfile, ...passwordForm }}
          validationSchema={validationSchema(isChangePwd)}
          onSubmit={(values) => onSubmit(values, isChangePwd)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldValue,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form>
                <PasswordConfirmation
                  isOpen={openModal}
                  onCancel={() => setOpenModal(false)}
                  onConfirm={() => {
                    setOpenModal(false);
                    props.onSubmit(values, isChangePwd);
                  }}
                />
                <Row className="mb-10">
                  <Col>
                    <Input
                      required
                      readOnly={values.name}
                      id="name"
                      label="First Name"
                      onChange={handleChange('name')}
                      value={values.name}
                      invalid={errors.name && touched.name}
                      error={errors.name}
                    />
                    <Input
                      required
                      readOnly={values.surname}
                      id="surname"
                      label="Last Name"
                      onChange={handleChange('surname')}
                      value={values.surname}
                      invalid={errors.surname && touched.surname}
                      error={errors.surname}
                    />
                    <Input
                      id="title"
                      label="Title"
                      onChange={handleChange('title')}
                      value={values.title}
                      invalid={errors.title && touched.title}
                      error={errors.title}
                    />
                    <Input
                      required
                      id="email"
                      label="Email"
                      onChange={handleChange('email')}
                      value={values.email}
                      invalid={errors.email && touched.email}
                      error={errors.email}
                    />
                    <FormGroup>
                      <Label>
                        {t('Work Days')} <Required />
                      </Label>
                      {workDays.map((workDay, index) => (
                        <CustomInput
                          key={index}
                          type="checkbox"
                          id={workDay.label}
                          checked={
                            values.workDaysOfWeek
                              ? values.workDaysOfWeek.includes(workDay.value)
                              : false
                          }
                          label={workDay.label}
                          onChange={(e) =>
                            //prettier-ignore
                            selectWorkDay(e, workDay.value, values.workDaysOfWeek, setFieldValue)
                          }
                          inline
                        />
                      ))}
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="startWork">
                        {t('Start Work')} <Required />
                      </Label>
                      <DatePicker
                        id="startWork"
                        className="form-control"
                        selected={values.startWork}
                        onChange={(date) => setFieldValue('startWork', date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat={timeFormat}
                        dateFormat={timeFormat}
                      />
                      {errors.startWork && touched.startWork && (
                        <FormFeedback>{t(errors.startWork)}</FormFeedback>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="endWork">
                        {t('End Work')} <Required />
                      </Label>
                      <DatePicker
                        id="endWork"
                        className="form-control"
                        selected={values.endWork}
                        onChange={(date) => setFieldValue('endWork', date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat={timeFormat}
                        dateFormat={timeFormat}
                      />
                      {errors.endWork && touched.endWork && (
                        <FormFeedback>{t(errors.endWork)}</FormFeedback>
                      )}
                    </FormGroup>
                    <Input
                      id="workContact"
                      label="Work Contact"
                      onChange={handleChange('workContact')}
                      value={values.workContact}
                      invalid={errors.workContact && touched.workContact}
                      error={errors.workContact}
                    />
                    <Input
                      id="nonWorkContact"
                      label="Non Work Contact"
                      onChange={handleChange('nonWorkContact')}
                      value={values.nonWorkContact}
                      invalid={errors.nonWorkContact && touched.nonWorkContact}
                      error={errors.nonWorkContact}
                    />
                    <Input
                      required
                      readOnly={values.initials}
                      id="initials"
                      label="Initials"
                      onChange={handleChange('initials')}
                      value={values.initials}
                      invalid={errors.initials && touched.initials}
                      error={errors.initials}
                    />
                    <div className="d-flex">
                      <Label>Use Custom Dashboard</Label>
                      <Toggle
                        className="dark-mode-toggle ml-10"
                        checked={values.useCustomDashboard}
                        onChange={({ target }) =>
                          setFieldValue('useCustomDashboard', target.checked)
                        }
                        aria-label="Dark mode toggle"
                      />
                    </div>
                    {/* <Dropdown
                      required
                      type="dynamic"
                      includeZero
                      label="Department"
                      data={departments}
                      value={values.departmentName}
                      onChange={({ value, text }) => {
                        setFieldTouched('departmentId', false);
                        setFieldValue('departmentId', value);
                        setFieldValue('departmentName', text);
                      }}
                      valueKey="id"
                      nameKey="name"
                      subtitleKey="id"
                      invalid={errors.departmentId && touched.departmentId}
                      error={errors.departmentId}
                    /> */}
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>{t('Password')}</Label>
                      <Button
                        color="primary"
                        className="flat"
                        style={{ fontSize: 14 }}
                        onClick={() => setIsChangePwd(!isChangePwd)}
                      >
                        {t(isChangePwd ? 'Cancel' : 'Change')}
                      </Button>
                    </FormGroup>
                    <Collapse isOpen={isChangePwd}>
                      <Input
                        required
                        id="currentPassword"
                        type="password"
                        label="Current Password"
                        onChange={handleChange('currentPassword')}
                        value={values.currentPassword}
                        invalid={touched.currentPassword}
                        error={errors.currentPassword}
                      />
                      <Input
                        required
                        id="password"
                        type="password"
                        label="New Password"
                        onChange={handleChange('password')}
                        value={values.password}
                        invalid={touched.password}
                        error={errors.password}
                        accessory={
                          <meter
                            max="4"
                            value={getPasswordStrength(values.password)}
                          />
                        }
                      />
                      <Input
                        required
                        id="confirmPassword"
                        type="password"
                        label="Confirm Password"
                        onChange={handleChange('confirmPassword')}
                        value={values.confirmPassword}
                        invalid={touched.confirmPassword}
                        error={errors.confirmPassword}
                      />
                    </Collapse>
                  </Col>
                </Row>
                <Alert.Error text={props.errors} />
                <div className="d-flex mt-20">
                  <CommonButton
                    id="submit-my-profile"
                    classes="mr-10"
                    loading={isSubmitting}
                    onClick={handleSubmit}
                  >
                    <i className="md-icon">done</i>
                    {t('Save')}
                  </CommonButton>
                  <Button
                    color="primary"
                    className="flat ml-10"
                    style={{ fontSize: 14 }}
                    onClick={props.onBack}
                  >
                    {t('Back')}
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(MyProfilePage);
